import { Box, Flex, Stack } from '@chakra-ui/react';
import ArticleCard from '@components/articles/SeoArticleCard';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import { MaStateData } from './data/maStateData';

const BestMaIndex = ({ maStateData }: { maStateData: MaStateData }) => (
  <DefaultLayout>
    <Stack bg="tan" py={[10, 10, 70]} px={antlerStyle.px} spacing={[6, 6, 10, 10]}>
      <Box pb={[0, 0, 8]}>
        <Header as="h2" textAlign="center">
          Medicare Advantage by State
        </Header>
      </Box>
      {Object.values(maStateData).map((stateData, index) => (
        <Flex w="100%" justifyContent="center" key={stateData.state}>
          <ArticleCard stateData={stateData} index={index} />
        </Flex>
      ))}
    </Stack>
  </DefaultLayout>
);

export default BestMaIndex;
